export let LookupTypes = {
  university: "University",
  qualification: "Qualification",
  Features: "FeaturesInHomeScreen",
  AdministrativeStaff:"AdministrativeStaff"
};
